import { __assign } from 'tslib';

var comparisonBarTitle = {
    base: { font: "sm", display: "flex", justifyContent: "center" },
};
var comparisonBars = {
    base: { width: "100%", minWidth: "auto" },
};
var comparisonBarContainer = {
    base: {
        display: "grid",
        gridTemplateColumns: "50px 4fr 4fr 50px",
        font: "sm",
    },
};
var comparisonBar = {
    base: {
        position: "relative",
        boxSizing: "border-box",
        backgroundColor: "black.10",
        color: "primary.100",
        width: "100%",
        height: "21px",
        borderRadius: 1,
    },
};
var comparisonBarLeft = {
    base: __assign(__assign({}, comparisonBar.base), { borderTopRightRadius: 0, borderBottomRightRadius: 0 }),
};
var comparisonBarRight = {
    base: __assign(__assign({}, comparisonBar.base), { borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }),
};

export { comparisonBar, comparisonBarContainer, comparisonBarLeft, comparisonBarRight, comparisonBarTitle, comparisonBars };
//# sourceMappingURL=comparison-bar.js.map
